const state = {
    stocks : []
}
const mutations = {
    'SET_STOCKS' ( state, stocks ) {
        state.stocks = stocks;
    },

    'SET_OPTION_ACTIVE_STOCKS' ( {commit}, {stock, option} ) {
        if ( stock ) {
            stock.print_options[option.parent].options.forEach( function( element ) {
                element.isActive = 0;
            } );
            option.isActive = 1;
        }
        stock.isReady = 1;
    },
};
const actions = {
    initStocks            : ( {commit} ) => {
        commit( 'SET_STOCKS', stocks );
    },
       setOptionActiveStock       : ( {commit}, params ) => {
        commit( 'SET_OPTION_ACTIVE_STOCKS', params );
    },
};
const getters = {
    stocks : state => {
        return state.stocks;
    }
}
const computed = {


}
export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/stocks.js